/**
 * Device detection helpers.
 *
 * Plain values (no reactive state): the device does not change at runtime.
 * Safe to call during SSR / tests — returns false when Web APIs are missing.
 */

function getUserAgent() {
  if (typeof navigator === "undefined") return "";
  return navigator.userAgent ?? navigator.vendor ?? "";
}

export function isIos() {
  if (typeof window === "undefined" || typeof navigator === "undefined") return false;
  if (/iphone|ipad|ipod/i.test(getUserAgent())) return true;
  return navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
}

export function isAndroid() {
  if (typeof navigator === "undefined") return false;
  return /android/i.test(getUserAgent());
}

export function isMobile() {
  return isIos() || isAndroid();
}

export function isStandalone() {
  if (typeof window === "undefined") return false;
  try {
    if (window.matchMedia?.("(display-mode: standalone)").matches) return true;
  } catch {
    // matchMedia unavailable (old jsdom, SSR): fall through.
  }
  return window.navigator?.standalone === true;
}

export default function useDevice() {
  return {
    isIos: isIos(),
    isAndroid: isAndroid(),
    isMobile: isMobile(),
    isStandalone: isStandalone(),
  };
}
